import React from "react";
import { Button } from "antd";
import { formatCEP, formatTelefone } from "../../../../../../../function/utilis/function";
import styles from "./GroupInicio.module.css";

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

/** Campo booleano (Sim/Não), mostrado como badge em vez de rádio desabilitado. */
function CampoBadge({ rotulo, valor }) {
  const indefinido = valor === null || valor === undefined;
  return (
    <div className={styles.campo}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span
        className={`${styles.badge} ${
          indefinido ? styles.badgeIndefinido : valor ? styles.badgeSim : styles.badgeNao
        }`}
      >
        {indefinido ? "Não informado" : valor ? "Sim" : "Não"}
      </span>
    </div>
  );
}

export function GroupInicio({ info, setIsModalAtualizarCliente }) {
  return (
    <div className={styles.painel}>
      <div className={styles.cabecalho}>
        <div>
          <h3 className={styles.titulo}>Dados de Triagem</h3>
          <p className={styles.subtitulo}>Informações coletadas na solicitação, antes da abertura da Ordem de Serviço.</p>
        </div>
        <Button type="primary" className={styles.botaoAtualizar} onClick={() => setIsModalAtualizarCliente(true)}>
          Atualizar dados
        </Button>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Contato</h4>
        <div className={styles.grade}>
          <Campo rotulo="Telefone" valor={info.telefone ? formatTelefone(info.telefone) : null} />
          <Campo rotulo="Email" valor={info.email} largo />
          <Campo rotulo="CEP" valor={info.triagemCep ? formatCEP(info.triagemCep) : null} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Endereço</h4>
        <div className={styles.grade}>
          <Campo rotulo="Sede da empresa" valor={info.triagemSedeEmpresa} largo />
          <Campo rotulo="Número" valor={info.triagemEnderecoNumero} />
          <Campo rotulo="Complemento" valor={info.triagemComplemento} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Empresa</h4>
        <div className={styles.grade}>
          <Campo rotulo="Segmento da empresa" valor={info.triagemSegmentoAtuacao} largo />
          <Campo rotulo="Nome fantasia" valor={info.triagemNomeFantasia} largo />
          <Campo rotulo="Capital social" valor={info.capitalSocial} />
          <Campo rotulo="Quantidade de sócios" valor={info.triagemQtdSocios} />
          <Campo rotulo="Estado civil" valor={info.triagemEstadoCivil} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Imóvel</h4>
        <div className={styles.grade}>
          <Campo rotulo="Metros quadrados da empresa" valor={info.triagemMetragemUtilizado} />
          <CampoBadge rotulo="Imóvel totalmente ocupado pela empresa?" valor={info.triagemUtilizaImovelInteiro} />
          <CampoBadge rotulo="Residência e empresa no mesmo local?" valor={info.triagemImovelResidencia} />
        </div>
      </div>
    </div>
  );
}

export default GroupInicio;
